// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-sandbox-theme -> repli-sandbox-sandbox-theme -> one-lakefront
// Generated: 2026-10-21T21:36:49.192Z
// Counts: 0 design, 1 content, 0 slot group, 0 collection binding, 1 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplan-units.layout": {
    "overrideType": "VALUE",
    "customValue": "rows",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "floor-plans": [
    {
      "sectionId": "floorplans",
      "blockId": "floorplans",
      "position": 2
    }
  ]
};

export const styleOverrides = {};
